import React from "react";
import { Paper, Stack, styled, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import NavDrawer from "../helpers/NavDrawer";
import AdminNavBar from "./AdminNavBar";

const StyledPaper = styled(Paper)`
  display: flex;
  height: 100%;
  width: 100%;
  padding: 4em 0;
`;

const StyledNavContainer = styled(Stack)`
  width: 100%;
`;

const StyledOutletContainer = styled(Stack)`
  width: 100%;
  padding: 2em;
`;

const AdminLayout = ({
  ...props
}) => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  return (
    <StyledPaper
      component={Stack}
      minWidth={{
        xs: "clamp(280px, 100%, 570px)",
        md: 700,
        lg: 900,
      }}
      elevation={5}
      {...props}
    >
      <StyledNavContainer
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        {isXsScreen ? (
          <NavDrawer>
            <AdminNavBar/>
          </NavDrawer>
        ) : (
          <AdminNavBar/>
        )}
        <StyledOutletContainer maxWidth={{
          md: "calc(100% - 200px)",
        }}>
          <Outlet/>
        </StyledOutletContainer>
      </StyledNavContainer>
    </StyledPaper>
  );
};

export default AdminLayout;